import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";
import { AgentAccessLevel } from "~/services/agents";

const ACCESS_LEVEL_LABEL: Record<AgentAccessLevel, string> = {
  [AgentAccessLevel.MANAGER]: "Owner",
  [AgentAccessLevel.EDITOR]: "Editor",
  [AgentAccessLevel.USER]: "User",
};

interface AgentAccessBadgeProps {
  accessLevel: AgentAccessLevel | null;
}

export function AgentAccessBadge({ accessLevel }: AgentAccessBadgeProps) {
  return <AccessBadge label={accessLevel ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
